import { getAnalitycStorage } from "./analytics";

if (typeof DFI_client != "object") {
    var DFI_client = {};
  }
  
  if (typeof DFI_client.containers != "object") {
    DFI_client.containers = {};
  }


function getCookieGA() {
    return new Promise(async (resolve, reject) => {
      let cookies = document.cookie.split(';');
      var cookiesGA = {
        _ga: "_ga=",
        ga4_sessionL: "_ga_L6WVX7EBK4=",
      };
  
      for (let key in cookiesGA) {
        let nameComplete = cookiesGA[key];
        for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i].trim();
          if (cookie.indexOf(nameComplete) === 0) {
            cookiesGA[key] = decodeURIComponent(cookie.substring(nameComplete.length, cookie.length));
            break; // Salir del bucle for cuando se encuentra una cookie correspondiente
          }else{
            cookiesGA[key] = null;
          }
        }
      }
      resolve(cookiesGA);
    })
}


// Función para obtener el valor de una cookie específica
function getCookie(name) {
    return new Promise((resolve, reject) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        (parts.length === 2) ? resolve(parts.pop().split(';').shift()) : false;
    })
}

async function getCookiesGoogleForPasarela() {
    var currentObjectCookiesGoogle = await getCookieGA();
    if(currentObjectCookiesGoogle){
        if (Object.keys(currentObjectCookiesGoogle).some(key => currentObjectCookiesGoogle[key] !== null)){
            // Carga cookies a la pasarela google
            let currentObjectCookiesGoogle = await getCookieGA()
            cargarEtiquetasPasarelaGoogle(currentObjectCookiesGoogle);
        }
    }
}

function cargaDeclarativas() {
  const interval = setInterval(()=>{
    if(typeof DRP == "function"){
      if(typeof DFI === "object"){
        clearInterval(interval)
        for (const [key, value] of Object.entries(dataLayerMovistarProsegur)) {
          if(key=="ad_personalization" || key=="ad_storage" || key=="ad_user_data" || key=="analytics_storage" || key=="functionality_storage" || key=="personalization_storage" || key =="security_storage"){
            DFI.labels.EDeclaratives[key] = value
          }
        }
        // Nueva solicitud para actualizar el ringpool con las nuevas etiquetas
        DFI.refreshRingpool();
      }
    }
  },100)
 
}

function analyticsWatchCookie() {
    const {
      ad_storage,
      ad_personalization,
      ad_user_data,
      analytics_storage,
      functionality_storage,
      personalization_storage,
      security_storage,
    } = getAnalitycStorage();

    dataLayerMovistarProsegur.ad_storage=ad_storage;
    dataLayerMovistarProsegur.ad_personalization=ad_personalization;
    dataLayerMovistarProsegur.ad_user_data=ad_user_data;
    dataLayerMovistarProsegur.analytics_storage=analytics_storage;
    dataLayerMovistarProsegur.functionality_storage=functionality_storage;
    dataLayerMovistarProsegur.personalization_storage=personalization_storage;
    dataLayerMovistarProsegur.security_storage=security_storage;
   
    cargaDeclarativas()
  }

export async function watchCookie() {
    let timeoutId = null; // ID del timeout para poder cancelarlo más tarde
    const startTime = Date.now(); // Tiempo de inicio para calcular el tiempo transcurrido
    const maxDuration = 3 * 60 * 1000; // Tiempo para parar el observador
    var check = false;

    const checkCookieChange = async () => {  
        // Verifica si han pasado X minutos desde que comenzó la observación
        if (Date.now() - startTime >= maxDuration) {
            return; // Detiene la función si han pasado 5 minutos
        }

        let currentCookieValue = await getCookie("_ga");

        // Verificar si la condición específica se cumple para detener la observación
        if (currentCookieValue != false && typeof DFI != "undefined" && !check) {
            check = true;
            // Get conset cookies y carga en datalayer/declarativas
            analyticsWatchCookie();

            window.location.href.indexOf("https://movistarproseguralarmas.es/") > -1 ? getCookiesGoogleForPasarela() : "";
            return;
        } else {
            const timeoutId = setTimeout(() => {
              clearTimeout(timeoutId);
              checkCookieChange()  
            }, 1000);
          }
            
    }   
  
    // Iniciar la observación de la cookie
      checkCookieChange();
    
    
  
    // Establecer un límite de tiempo para detener la observación después de 3 minutos
    setTimeout(() => {
      clearTimeout(timeoutId);
    }, maxDuration);
  }



//  Carga cookies de google a la pasarela
async function cargarEtiquetasPasarelaGoogle(currentCookieValue){
    [DFI_client.containers.ga, DFI_client.containers.gaSession] = Object.values(currentCookieValue);

    DFI_client.containers.idTagForGA4Cookies = "6044ae0ff5040363ec1f7fe5720b7964";
    DFI_client.containers.timeIntervalGA4SCookies = 350;
    DFI_client.containers.g4sFlag = false;
    // We send Universal Analytics and GA4S
    if (DFI_client.containers.g4sFlag != true && DFI_client.containers.gaSession != null) {

        DFI_client.containers.intervalPiwikGA4SCookies = setInterval(() => {
            if (typeof Piwik != "undefined" && typeof Piwik.getAsyncTracker() != "undefined" && Boolean(Piwik.getAsyncTracker().getVisitorId())) {
            clearInterval(DFI_client.containers.intervalPiwikGA4SCookies);

            if (DFI_client.containers.timeIntervalGA4SCookies === 350) {
                DFI_client.containers.timeIntervalGA4SCookies = 50000000;
                DFI_client.containers.g4sFlag = true;
                // Universal Analytics and ga4 id
                DFI_client.containers.analyticsEpst = `https://t.womtp.com/epst/v2?idsite=${DFI_client.containers.idTagForGA4Cookies}&idvisitor=${Piwik.getAsyncTracker().getVisitorId()}&v=1&gaid4=${DFI_client.containers.ga}&ga4sid=${DFI_client.containers.gaSession}`;
                DAL.Ajax({
                type: "jsonp",
                url: DFI_client.containers.analyticsEpst,
                method: "GET",
                }).done(function(resp){
                console.log(resp);
                })
            }
            }
        }, DFI_client.containers.timeIntervalGA4SCookies);
    }

}
    